import { Box, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { tokens } from "../../../../../../theme";

import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from "react-i18next";
import MAddOrderField from "../../../../../../components/global/Modals/MAddOrderField";
import ButtonGroup from "../../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../../components/theme/datagrid2/ShDataGrid2";
import ShTextSkeleton from "../../../../../../components/theme/skeleton/ShTextSkeleton";
import SidepanelLoader from "../../../../../../components/theme/sidepanel2/SidepanelLoader";
import { selectUserPermission } from "../../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../../../utils/permissions";
import { useSelector } from "react-redux";
import { generateColorFromTitle, generateIconColorFromTitle } from "../../../../../../components/theme/TabView3/IconColorGenerator";
import Text from "../../../../../../components/theme/text/Text";
import ProductExtraFieldsCard from "../../../../../../components/global/cards/settings/ProductExtraFieldsCard";
import { useGetOrderFieldsQuery } from "../../../../../../newapi/order/orderFieldSlice";
import { useAddInternalReasonsMutation, useGetInternalReasonsQuery } from "../../../../../../newapi/internalreason/internalReasonSlice";
import MConfirmationWithValue from "../../../../../../components/global/Modals/MConfirmationWithValue";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../../../../utils/toasts";

const SpReasonDetails = SidepanelLoader(() => import("../../../../../../components/global/Sidepanels/SpReasonDetails/SpReasonDetails"));

const GridActions = (props, i18n) => {
    const theme = useTheme();
    useEffect(() => {},[props.open]);

    const {t} = useTranslation();
    return (      
        <ButtonGroup version={2}>
            <Shbutton 
                onClick={() => props.handleOpen(true)}
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                variant="contained" 
                endIcon={<AddIcon/>}>
                    {t("new_reason")}
            </Shbutton>
        </ButtonGroup>
    );
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};

const Stockmutation = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended,setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const [config, setConfig] = useState({types: ["stockmutation"]});

    const [newReason, setNewReason] = useState();
    const [newReasonModalOpen, setNewReasonModalOpen] = useState(false);
    const newReasonModal = {
        open: newReasonModalOpen,
        setOpen: setNewReasonModalOpen
    }

    const handleNewReasonModalClose = () => {
        newReasonModal.setOpen(false);
    }
    
    const [createNewReason,{isLoading: createLoading}] = useAddInternalReasonsMutation();
    const handleNewReasonConfirm = async() => {
        console.log(newReason);
        try {
            if (createLoading) return;

            const data = await createNewReason({
                type: "stockmutation",
                description: newReason
            }).unwrap();
            showToastMessagePostRequest(t, data);
            setNewReason("");
        } catch (err) {
            showToastMessageRequestError(t("create_failed"), t, err);
        }
    }

    const handleNewReasonChange = (val) => {
        setNewReason(val);
    }

    const [reasonId, setReasonId] = useState();
    const reasonIdRef = useRef(reasonId);
    
    const getReasonDetails = (params) => {
        if (!params) return;
    
        const newReasonId = parseInt(params.row.id);
        // Only update state if the webshopCredentialsId has actually changed
        if (reasonIdRef.current !== newReasonId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setReasonId(newReasonId);
            reasonIdRef.current = newReasonId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions:gridOptions,
            mobileActions:<GridActions handleOpen={() => setNewReasonModalOpen(true)}></GridActions>
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[setNewReasonModalOpen]);
    
    const columns = [
        {field: "description", headerName: t("description"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return <Text semibold>{params.row.description}</Text>
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <ProductExtraFieldsCard 
                        skeleton={params.row.skeleton ?? false}
                        onClick={() => getReasonDetails(params)}
                        {...params.row}
                    />
                )
            }
        }
    ];

    return (
        <Box
            sx={{
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
            
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetInternalReasonsQuery}
                config={config}
                gridActions={<GridActions handleOpen={() => setNewReasonModalOpen(true)}></GridActions>} 
                title={t("stockmutation_reasons")}
                gridOptions={gridOptions} 
                sortModel={{field: columns[0].field,type:"ASC"}}
                    
                columns={columns}
                onRowClick={getReasonDetails}>
            </ShDataGrid2>


            <MConfirmationWithValue
                open={newReasonModal.open}
                handleClose={handleNewReasonModalClose}
                confirm={() => handleNewReasonConfirm()}
                onChange={handleNewReasonChange}
                data={{title: t("mc_new_reason_stockmutation"), value: newReason, hasInput: true, inputLabel: t('reason'), inputType: "text"}}
            />


            {spLoading && 
                <SpReasonDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    reasonId={reasonId}
                    // data={credentialData}  
                /> 
            }
        </Box>
    )
};

export default Stockmutation;